import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ChangeEvent, Dispatch, MouseEvent, SetStateAction } from "react";
import { DatePickerEventFormData, ITodo } from "./EventCalendar";

interface IProps {
  open: boolean;
  handleClose: Dispatch<SetStateAction<void>>;
  datePickerEventFormData: DatePickerEventFormData;
  setDatePickerEventFormData: Dispatch<SetStateAction<DatePickerEventFormData>>;
  onAddEvent: (e: MouseEvent<HTMLButtonElement>) => void;
  todos: ITodo[];
  currentEvent?: any;
}

const AddDatePickerEventModal = ({
  open,
  handleClose,
  datePickerEventFormData,
  setDatePickerEventFormData,
  onAddEvent,
  todos,
  currentEvent,
}: IProps) => {
  const { receipts_number, day } = datePickerEventFormData;

  console.log({ currentEvent });

  const onClose = () => {
    handleClose();
  };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setDatePickerEventFormData((prevState) => ({
      ...prevState,
      receipts_number: Number(event.target.value),
    }));
  };

  const isDisabled = () => {
    if (receipts_number === null || day === null) {
      return true;
    }
    return false;
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {currentEvent?.slots[0] !== undefined ? "Edit" : "Create"} receipts
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          To add receipts, please fill in the information below.
        </DialogContentText>
        <Box component="form">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box mb={2} mt={5}>
              <DatePicker
                label="Day"
                value={currentEvent?.slots[0] ? currentEvent?.slots[0] : day}
                disabled={currentEvent?.slots[0]}
                onChange={(newValue) => {
                  newValue?.setHours(5, 0, 0, 0);
                  setDatePickerEventFormData((prevState) => ({
                    ...prevState,
                    day: new Date(newValue!),
                  }));
                }}
              />
            </Box>
          </LocalizationProvider>
          <TextField
            name="description"
            value={receipts_number}
            margin="dense"
            id="receipts"
            label="Receipts"
            type="number"
            fullWidth
            variant="outlined"
            onChange={onChange}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={onClose}>
          Cancel
        </Button>
        <Button disabled={isDisabled()} color="success" onClick={onAddEvent}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDatePickerEventModal;
